import { StyleSheet } from 'aphrodite'

import main from './main'
import headers from './headers'
import list from './list'

export default {
  main: StyleSheet.create(main),
  headers: StyleSheet.create(headers),
  list: StyleSheet.create(list)
}



// WEBPACK FOOTER //
// ./src/components/Info/style/index.js